import { Navbar } from "components/Navbar"
import { PropsWithChildren } from "react"
import { Box } from "@strapi/design-system"

export interface IPageLayout extends PropsWithChildren {}

export const PageLayout = ({ children }: IPageLayout) => {
  return (
    <Box background="neutral100" style={{ display: "flex", minHeight: "100vh" }}>
      <Box
        as="nav"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          maxWidth: "230px",
          backgroundColor: "#f6f6f9",
          zIndex: 2,
        }}
      >
        <Navbar />
      </Box>

      <Box
        style={{
          marginLeft: "230px",
          flex: 1,
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
